import React from 'react';

import { Icon } from '../icons';

export const ChatBubbleWarningIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 18 18" stroke={color} style={style}>
      <>
        <g clipPath="url(#clip0_1818_384199)">
          <path d="M9 8.625V12.375" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M9 5.6325L9.0075 5.62417" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 10.3661 1.86523 11.6468 2.50337 12.75L1.875 16.125L5.25 15.4966C6.35315 16.1348 7.63392 16.5 9 16.5Z"
            fill="transparent"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1818_384199">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </>
    </svg>
  );
};
